import { MY_PROFILE_CONSTANTS } from "@myProfile/constants";

/**
 * Composes a user's display name. Group-email contacts are stored system-wide as
 * firstName = <group name>, lastName = "Team" (see GROUP_EMAIL_DEFAULT_LAST_NAME and the
 * Salesforce mapping) — there is no real group flag in the entitlement profile, so the
 * sentinel last name is collapsed to show just the group name.
 */
export const buildDisplayName = (firstName: string, lastName: string): string =>
  lastName === MY_PROFILE_CONSTANTS.GROUP_EMAIL_DEFAULT_LAST_NAME
    ? firstName.trim()
    : `${firstName} ${lastName}`.trim();
